import styled from 'styled-components';

import { grey1 } from 'approot/shared/styles/colours.style';

type PagePreviewWrapperProps = {
  $isLoading?: boolean;
};
export const ComponentPreviewWrapper = styled.div<PagePreviewWrapperProps>`
  background-color: ${grey1};
  transition: opacity 200ms ease;
  opacity: ${({ $isLoading }) => ($isLoading ? 0 : 1)};
  padding-top: 56%;
  position: relative;
  width: 100%;
`;

export const ComponentPreview = styled.div`
  inset: 0;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  transform-origin: left top;
`;

type ComponentHiddenSizeRenderPreviewProps = {
  $width: number;
};
export const ComponentHiddenSizeRenderPreview = styled.div<ComponentHiddenSizeRenderPreviewProps>`
  position: fixed;
  top: -100000px;
  opacity: 0;
  width: ${({ $width }) => `${$width}px`};
`;
